export const formatTitle = (name: string) => {
  return name.split('-').length === 1 ? name : name.split('-').join(' ');
};
